/**
 * List of US states
 */
export function usaStates() {
  const usaStates = [
    { value: "al", label: "Alabama" },
    { value: "ak", label: "Alaska" },
    { value: "az", label: "Arizona" },
    { value: "ar", label: "Arkansas" },
    { value: "ca", label: "California" },
    { value: "co", label: "Colorado" },
    { value: "ct", label: "Connecticut" },
    { value: "de", label: "Delaware" },
    { value: "fl", label: "Florida" },
    { value: "ga", label: "Georgia" },
    { value: "hi", label: "Hawaii" },
    { value: "id", label: "Idaho" },
    { value: "il", label: "Illinois" },
    { value: "in", label: "Indiana" },
    { value: "ia", label: "Iowa" },
    { value: "ks", label: "Kansas" },
    { value: "ky", label: "Kentucky" },
    { value: "la", label: "Louisiana" },
    { value: "me", label: "Maine" },
    { value: "md", label: "Maryland" },
    { value: "ma", label: "Massachusetts" },
    { value: "mi", label: "Michigan" },
    { value: "mn", label: "Minnesota" },
    { value: "ms", label: "Mississippi" },
    { value: "mo", label: "Missouri" },
    { value: "mt", label: "Montana" },
    { value: "ne", label: "Nebraska" },
    { value: "nv", label: "Nevada" },
    { value: "nh", label: "New Hampshire" },
    { value: "nj", label: "New Jersey" },
    { value: "nm", label: "New Mexico" },
    { value: "ny", label: "New York" },
    { value: "nc", label: "North Carolina" },
    { value: "nd", label: "North Dakota" },
    { value: "oh", label: "Ohio" },
    { value: "ok", label: "Oklahoma" },
    { value: "or", label: "Oregon" },
    { value: "pa", label: "Pennsylvania" },
    { value: "ri", label: "Rhode Island" },
    { value: "sc", label: "South Carolina" },
    { value: "sd", label: "South Dakota" },
    { value: "tn", label: "Tennessee" },
    { value: "tx", label: "Texas" },
    { value: "ut", label: "Utah" },
    { value: "vt", label: "Vermont" },
    { value: "va", label: "Virginia" },
    { value: "wa", label: "Washington" },
    { value: "wv", label: "West Virginia" },
    { value: "wi", label: "Wisconsin" },
    { value: "wy", label: "Wyoming" },
    { value: "dc", label: "District of Columbia" },
    { value: "as", label: "American Samoa" },
    { value: "gu", label: "Guam" },
    { value: "mp", label: "Northern Mariana Islands" },
    { value: "pr", label: "Puerto Rico" },
    { value: "um", label: "United States Minor Outlying Islands" },
    { value: "vi", label: "Virgin Islands, U.S." },
  ];

  return usaStates;
}

/**
 * Only the last 5 years will be generated
 */
export function taxableYears() {
  const currentYear = new Date().getFullYear() - 1;
  const years = Array.from({ length: 3 }, (_, i) =>
    Object.create({ value: currentYear + i * -1, label: currentYear + i * -1 })
  );
  return years;
}

/**
 * Generate years from previous year back to 1950 for business formation
 */
export function businessFormedYear() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 1; // Start from previous year (2025)
  const endYear = 1900;
  const numberOfYears = startYear - endYear + 1;

  const years = Array.from({ length: numberOfYears }, (_, i) => {
    const year = startYear - i;
    return { value: year, label: year };
  });

  return years;
}

export function filingAllowedForms(allowedFormTypes) {
  let documents = [];

  // Safety check: ensure allowedFormTypes is an array
  if (!allowedFormTypes || !Array.isArray(allowedFormTypes)) {
    return documents;
  }

  allowedFormTypes.forEach((allowedType) => {
    documents.push({ value: allowedType, label: allowedType });
  });
  return documents;
}

export function filingAllowedTaxpreparerForms(allowedFormTypes) {
  let documents = [];

  // Safety check: ensure allowedFormTypes is an array
  if (!allowedFormTypes || !Array.isArray(allowedFormTypes)) {
    return documents;
  }

  allowedFormTypes.forEach((allowedType) => {
    documents.push({ value: allowedType, label: allowedType });
  });
  return documents;
}

/**
 * Select for Type of Business
 */
export function businessType() {
  const business = [
    { value: "c_corporation", label: "C Corporation" },
    { value: "multi_member_llc", label: "Multi Member LLC" },
    { value: "llp", label: "LLP" },
  ];
  return business;
}

/**
 * Select for Support Request Types
 */
export function supportRequestTypes() {
  const types = [
    { value: "ACT", label: "Account Manage" },
    { value: "BLL", label: "Billing Question" },
    { value: "TCH", label: "Technical Problem" },
    { value: "FEA", label: "Feature Request" },
    { value: "FED", label: "Feedback / Suggestion" },
    { value: "BUG", label: "Bug Report" },
    { value: "GNR", label: "General Question" },
    { value: "PVC", label: "Privacy / Security" },
    { value: "LEG", label: "Legal / Compliance" },
    { value: "OTH", label: "Other" },
  ];
  return types;
}

/**
 * Select for Referral Service Types
 */
export function referralServiceTypes() {
  const services = [{ value: "TF", label: "Tax Filing" }];
  return services;
}

/**
 * CPA License types
 */
export function cpaLicenseTypes() {
  return [
    { value: "CP", label: "CPA" },
    { value: "EA", label: "EA" },
    { value: "AT", label: "Tax Attorney" },
  ];
}

/** Filing statuses list for a tax situation
 */
export function filingStatuses() {
  const statuses = [
    { value: "single", label: "Single" },
    { value: "married_filing_jointly", label: "Married Filing jointly" },
    { value: "married_filing_separately", label: "Married Filing separately" },
    { value: "head_of_household", label: "Head of Household" },
    { value: "Qualifying_widow", label: "Qualifying widow(er)" },
  ];
  return statuses;
}

export function businessFilingStatuses() {
  const statuses = [
    { value: "c_corporation", label: "C-Corporation" },
    { value: "s_corporation", label: "S-Corporation" },
    { value: "llp", label: "Limited Liability Partnership (LLP)" },
    { value: "multi_member_llc", label: "Partnership (Multi-Member LLC)" },
    { value: "n_profit", label: "Non-Profit" },
  ];

  return statuses;
}

export function adminActionTypes() {
  const types = [
    { value: "LICENSE_VALIDATION", label: "License Validation" },
    { value: "CPA_REMINDER", label: "CPA Reminder" },
    { value: "OTHER", label: "Other" },
  ];

  return types;
}

export function adminDecisions() {
  const decisions = [
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  return decisions;
}

export function adminOrdering() {
  const ordering = [
    { value: "-created_at", label: "Date (Newest First)" },
    { value: "created_at", label: "Date (Oldest First)" },
    { value: "action_type", label: "Action Type (A-Z)" },
    { value: "-action_type", label: "Action Type (Z-A)" },
    { value: "decision", label: "Decision (A-Z)" },
    { value: "-decision", label: "Decision (Z-A)" },
  ];

  return ordering;
}

export function pageSizes() {
  const sizes = [
    { value: "10", label: "10" },
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  return sizes;
}

export function cpaAccountStatuses() {
  const statuses = [
    { value: "TN", label: "Test Needed" },
    { value: "DN", label: "Documents Needed" },
    { value: "LR", label: "License Rejected" },
    { value: "CA", label: "Connect Account Needed" },
    { value: "LE", label: "Identity Verification Needed" },
  ];

  return statuses;
}

/**
 * Select for Purchased Assets Types
 */
export function puchasedAssetsType() {
  const assetTypes = [
    { value: "equipment", label: "Equipment" },
    { value: "vehicles", label: "Vehicles" },
    { value: "buildings_property", label: "Buildings / Property" },
    { value: "furniture_fixtures", label: "Furniture / Fixtures" },
    { value: "other_types", label: "Other Types" },
  ];

  return assetTypes;
}

/**
 * Select for Cryptocurrency Exchanges
 * 
 * documentType: "1099" | "transactions" - indicates how the exchange provides tax data
 * requiresCount: boolean - whether to ask for number of documents
 */
export function cryptocurrencyExchanges() {
  const exchanges = [
    { 
      value: "coinbase", 
      label: "Coinbase",
      code: "CB",  // Backend API code
      documentType: "1099",  // Coinbase provides 1099 forms
      requiresCount: true     // Need to ask how many 1099s
    },
    { 
      value: "kraken", 
      label: "Kraken",
      code: "KR",  // Backend API code
      documentType: "transactions",  // Kraken requires transaction CSV upload
      requiresCount: false
    },
  ];

  return exchanges;
}
